import React from 'react';

const MiniKPI = ({ label, value, icon = 'fa-circle', right = null }) => (
  <div className="card mini-kpi mb-3 h-100">
    <div className="card-body d-flex justify-content-between align-items-center">
      <div>
        <div className="text-muted small">{label}</div>
        <div className="h5 mb-0">{value}</div>
      </div>
      <div className="d-flex align-items-center">
        {right}
        <i className={`fas ${icon} ml-2`} />
      </div>
    </div>
  </div>
);

export default MiniKPI;
